import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export async function getDailyBrief() {
  const { data } = await client.get('/daily-brief');
  return data;
}

const dailyBriefService = { getDailyBrief };
export default dailyBriefService;
